import { snakeCase } from 'lodash-es';

import { UTM_KEYS as UTM_BASE_KEYS } from '@pflegia/types/common/constants/utm-keys';

export const UTM_KEYS = UTM_BASE_KEYS.map(key => snakeCase(key));
export const INITIAL_PREFIX = 'initial_';
export const INITIAL_UTM_TIMESTAMP = `initial_utm_timestamp`;
export const LATEST_UTM_TIMESTAMP = `latest_utm_timestamp`;
